import { GiftOutlined, HomeFilled } from "@ant-design/icons";
import { Dropdown, Image, Menu } from "antd";
import {
  MdCasino,
  MdContentCopy,
  MdDashboard,
  MdGames,
  MdImage,
  MdSubscriptions,
  MdNewspaper,
} from "react-icons/md";
import { TbBoxAlignTopRightFilled, TbUserQuestion } from "react-icons/tb";
import { NavLink, useNavigate } from "react-router-dom";
import logout from "../Assets/logout.png";
import LogoutAdmin from "../Assets/LogoutAdmin.png";
import { FcAdvertising } from "react-icons/fc";
import { RiAdvertisementFill } from "react-icons/ri";
const blogMenu = (
  <Menu>
    <Menu.Item key="1">
      <NavLink to="/blog/blogCategory">Blog Category</NavLink>
    </Menu.Item>
    <Menu.Item key="2">
      <NavLink to="/blog/blogData">Blog Data</NavLink>
    </Menu.Item>
  </Menu>
);
export const MenuItems = () => {
  const list = [
    {
      key: "1",
      icon: <MdContentCopy />,
      label: (
        <NavLink to={"/content/contentData"}>
          <p>Content Details</p>
        </NavLink>
      ),
    },
    {
      key: "2",
      icon: <MdGames />,
      label: (
        <NavLink to={"/add/match_content"}>
          <p> Match Content</p>
        </NavLink>
      ),
    },
    {
      key: "3",
      icon: <TbUserQuestion />,
      label: (
        <NavLink to={"/get/enquiry_details"}>
          <p>Enquiry Details</p>
        </NavLink>
      ),
    },
    {
      key: "4",
      icon: <GiftOutlined />,
      label: (
        <NavLink to={"/get/offers_details"}>
          <p>Offers Details</p>
        </NavLink>
      ),
    },

    {
      key: "5",
      icon: <MdImage />,
      label: (
        <NavLink to={"/get/banner_details"}>
          <p>Banner Details</p>
        </NavLink>
      ),
    },
    {
      key: "6",
      icon: <MdCasino />,
      label: (
        <NavLink to={"/get/casino_details"}>
          <p>Casino Details</p>
        </NavLink>
      ),
    },
    {
      key: "7",
      icon: <MdSubscriptions />,
      label: (
        <NavLink to={"/get/subscriber_details"}>
          <p>Subscribers Details</p>
        </NavLink>
      ),
    },
    {
      key: "8",
      icon: <TbUserQuestion />,
      label: (
        <NavLink to={"/get/user_details"}>
          <p>User Details</p>
        </NavLink>
      ),
    },
    {
      key: "9",
      icon: <MdNewspaper />,
      label: (
        <NavLink to={"/get/news_details"}>
          <p>News Details</p>
        </NavLink>
      ),
    },
    {
      key: "10",
      icon: <MdNewspaper />,
      label: (
        <NavLink to={"/get/blog_details"}>
          <p>Blog Details</p>
        </NavLink>
      ),
    },
    {
      key: "11",
      icon: <MdImage />,
      label: (
        <NavLink to={"/get/poster_details"}>
          <p>Poster Details</p>
        </NavLink>
      ),
    },
    {
      key: "12",
      icon: <RiAdvertisementFill />,
      label: (
        <NavLink to={"/get/advertisements_details"}>
          <p>Advertisement Details</p>
        </NavLink>
      ),
    },
    // {
    //   key: "9",
    //   icon: <HomeFilled />,
    //   label: (
    //     <NavLink to={"/addHomePage"}>
    //       <p>Home Page</p>
    //     </NavLink>
    //   ),
    // },
  ];
  return list;
};

export const LogoutMenuItem = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const list = [
    {
      key: "7",
      label: (
        <div
          onClick={handleLogout}
          style={{
            cursor: "pointer",
            borderTop: "2px solid",
            display: "flex",
            alignItems: "center",
            padding: "8px 12px",
            gap: "10px",
          }}
        >
          <Image preview={false} src={LogoutAdmin} width={25} height={25} />

          <p
            className="font-dmsans font-semibold text-base text-[#A3AED0]"
            style={{ margin: 0 }}
          >
            Admin
          </p>

          <Image
            preview={false}
            src={logout}
            width={20}
            height={20}
            title="Sign Out"
          />
        </div>
      ),
    },
  ];

  return list;
};
